export default "__VITE_ASSET__2bbfa748__"